// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__tFNxW","socialIcon":"Social_socialIcon__rsYld"};